/**
 * Returns true when pathname is the route itself or a real child path segment.
 *
 * @param {string} route
 * @param {string} pathname
 * @returns {boolean}
 */
export const isActiveRoute = (route, pathname) => {
  if (!route || !pathname) return false;
  if (route === pathname) return true;
  if (route === '/') return false;
  return pathname.startsWith(`${route}/`);
};
